// extracted by mini-css-extract-plugin
module.exports = {"content":"content_content__1O3NH","inner_content":"content_inner_content__2Cmz2"};